import { useEffect,useRef,useState,type ReactNode } from 'react'
import { Link,useNavigate,useSearchParams } from 'react-router-dom'
import { api } from '../../shared/api/http'
import { useAuth } from './AuthContext'

const pendingKey='spectra_pending_invitation'

export function InvitationEntry({fallback}:{fallback:ReactNode}){
 const {user}=useAuth(),navigate=useNavigate(),[query]=useSearchParams(),[status,setStatus]=useState<'idle'|'waiting'|'accepting'|'error'>('idle')
 const accepting=useRef(false)
 const supplied=query.get('invitation')?.trim()??''
 useEffect(()=>{
  if(supplied)sessionStorage.setItem(pendingKey,supplied)
  const token=supplied||sessionStorage.getItem(pendingKey)||''
  if(!token){setStatus('idle');return}
  if(!user){setStatus('waiting');return}
  if(accepting.current)return
  accepting.current=true
  let active=true;setStatus('accepting')
  api('/companies/invitations/accept',{method:'POST',body:JSON.stringify({token})}).then(()=>{sessionStorage.removeItem(pendingKey);if(active)navigate('/central',{replace:true})}).catch(()=>{sessionStorage.removeItem(pendingKey);if(active)setStatus('error')}).finally(()=>{accepting.current=false})
  return()=>{active=false}
 },[navigate,supplied,user])
 if(status==='idle')return fallback
 return <main className="invitation-page"><section><img src="/logo.png" alt="Spectra Guard AI"/><span className="eyebrow blue">CONVITE DE ACESSO</span>{status==='waiting'&&<><h1>Entre para aceitar o convite</h1><p>O vínculo será concluído depois que você entrar com o mesmo e-mail que recebeu o convite. Se ainda não tem conta, peça ao administrador para criá-la.</p><div><Link className="landing-primary" to="/login">Entrar</Link></div></>}{status==='accepting'&&<><h1>Aceitando convite…</h1><p>Estamos validando seu vínculo com a empresa.</p><span className="spinner dark"/></>}{status==='error'&&<><h1>Convite indisponível</h1><p>O convite pode ter expirado, já ter sido utilizado ou pertencer a outro e-mail.</p><Link className="landing-primary" to="/central">Ir para a central</Link></>}</section></main>
}
